import { useEffect } from "react";
import { useLocation } from "wouter";

/** Listens for navigation commands from the native WebView shell via CustomEvent. */
export const NativeNavigationListener = () => {
  const [, setLocation] = useLocation();

  useEffect(() => {
    if (!window.isWebView) return;

    const handler = (e: Event) => {
      const { type, threadId } = (e as CustomEvent).detail;
      if (type === "navigateToThread" && threadId) {
        setLocation(`/threads/${threadId}`);
      }
    };
    window.addEventListener("nativeNavigation", handler);
    return () => window.removeEventListener("nativeNavigation", handler);
  }, [setLocation]);

  return null;
};
